import { createQuery } from 'react-query-kit';

import { STALE_TIME } from '../../config/stale-time';
import type { AnyStrapiClient } from '../create-strapi-client';

type MakeStrapiQueriesOptions = {
    client: AnyStrapiClient;
    getAssetLogo?: (slug: string) => string;
};

const makeStrapiQueries = ({ client }: MakeStrapiQueriesOptions) => {
    const useGetAnalyticsPage = createQuery({
        queryKey: ['strapi-analytics-page'],
        fetcher: async () => client.get.analyticsPage(),
        staleTime: STALE_TIME.$1Hour,
    });

    const useGetDashboardGroups = createQuery({
        queryKey: ['strapi-dashboard-group'],
        fetcher: client.get.dashboardGroups,
        staleTime: STALE_TIME.$1Hour,
    });

    return {
        getAnalyticsPage: { use: useGetAnalyticsPage },
        getDashboardGroups: { use: useGetDashboardGroups },
    };
};

export { makeStrapiQueries };
